class Teacher {
	id = null;
	name = '';
	oib = '';
	buyer = false;
	supplier = false;
	headquarter = '';
	business = '';
	address = '';
	postal_code = '';
	city = '';
	country_id = null;
	phone = '';
	email = '';
	business = '';
	contact_person = '';
	rabat = 0;
	note = '';
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Teacher;
